<template>
  <div class="page-container">
    <div class="mod-box">
      <p class="mod-box-title">请填写您的信息，我们会有专业对接人员为您服务 &amp; 您也可以直接联系我们</p>
      <div class="form-box">
        <form class="form-horizontal">
          <div class="form-group form-group-lg form-item">

            <el-row>
              <el-col :span="8">
                <label class="col-md-2 control-label" for="name">姓名<span class="star">*</span>:</label>
              </el-col>
              <el-col :span="8">
                <el-input placeholder="请输入内容" v-model="realname">
                </el-input>
              </el-col>

            </el-row>
          </div>
          <div class="form-group form-group-lg form-item">
            <el-row>
              <el-col :span="8">
                <label class="col-md-2 control-label" for="phone">联系电话<span class="star">*</span>:</label>
              </el-col>
              <el-col :span="8">
                <el-input placeholder="请输入内容" v-model="phone">
                </el-input>
              </el-col>

            </el-row>
          </div>
          <div class="form-group form-group-lg form-item">

            <el-row>
              <el-col :span="8">
                <label class="col-md-2 control-label" for="productname">作品名称<span class="star">*</span>:</label>
              </el-col>
              <el-col :span="8">
                <el-input placeholder="请输入内容" v-model="productname">
                </el-input>
              </el-col>

            </el-row>
          </div>
          <div class="form-group form-group-lg form-item">

            <el-row>
              <el-col :span="8">
                <label class="col-md-2 control-label" for="count">作品数量<span class="star">*</span>:</label>
              </el-col>
              <el-col :span="8">
                <el-input placeholder="请输入内容" v-model="productcount">
                </el-input>
              </el-col>

            </el-row>
          </div>
          <el-button class="xt-btn" round @click="submit">立即提交</el-button>
        </form>
        <div class="cont-box">
          <div class="kefu-box">
            <img src="../../assets/image/custom.png" alt="">
          </div>
          <button type="button" class="btn btn-default btn-lg">联系我们</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from '../../utils/index';
import {
  Collect
} from '../../model/collect.js';
let collect = new Collect();
export default {
  name: 'collect',
  data() {
    return {
      realname: "",
      phone: "",
      productname: "",
      productcount: ""
    }
  },
  methods: {
    submit() {
      let _this = this;
      if (utils.isNull(_this.realname)) {
        this.$message.error('请输入姓名');
        return
      }
      if (utils.isNull(_this.phone)) {
        this.$message.error('请输入手机号');
        return
      }
      if (utils.isNull(_this.productname)) {
        this.$message.error('请输入作品名称');
        return
      }
      if (utils.isNull(_this.productcount)) {
        this.$message.error('请输入作品数量');
        return
      }
      if (!utils.isphone(_this.phone)) {
        this.$message.error('请输入正确的手机号');
        return
      }
      collect.productCollect({
        Realname: _this.realname,
        Phone: _this.phone,
        ProductName: _this.productname,
        ProductCount: _this.productcount
      }).then((res) => {
        _this.$alert(res, '提示', {
          confirmButtonText: '确定',
          callback: () => {
            _this.$router.push({ path: "/index/index" })
          }
        });
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.mod-box {
  margin-top: 40px;
  padding: 56px 78px 64px 40px;
  background-color: #ffffff;
  box-shadow: 0px 1px 7px 0px rgba(11, 3, 6, 0.3);
  font-size: 18px;
  line-height: 32px;
  color: #333;
  text-align: center;
  border-radius: 8px;
}

.mod-box .mod-box-title {
  margin-bottom: 30px;
}

.mod-box .mod-box-title > span.warning {
  color: #d11717;
}

.mod-box .form-item {
  margin-bottom: 20px;
}

.mod-box .form-item label .star {
  color: #a90000;
  letter-spacing: 5px;
  margin-left: 10px;
}

.mod-box .form-control {
  border-radius: 0;
}

.mod-box .form-control:focus {
  border: 1px solid #cfa972;
  box-shadow: 0px 0px 8px rgba(207, 169, 114, 0.6);
}

.mod-box .form-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
}

.mod-box .tips-box {
  padding-left: 30px;
  background: no-repeat 0 center;
  background-size: 20px 20px;
  text-align: left;
  margin-top: 6px;
  display: none;
  margin-left: 20px;
}

.mod-box .tips-box.fadein {
  display: block;
  transition: all 0.5s;
}

.mod-box .tips-box.tips-box-success {
  background-image: url(../../assets/image/icon-finish.png);
  color: #21cb5d;
}

.mod-box .tips-box.tips-box-danger {
  background-image: url(../../assets/image/icon-wrong.png);
  color: #d11717;
}

.mod-box .form-box .form-horizontal {
  flex: 9;
}

.mod-box .form-box .cont-box {
  flex: 2;
}

.mod-box .form-box .cont-box .kefu-box {
  width: 179px;
  height: 178px;
  margin: 0 auto;
  border-radius: 50%;
  overflow: hidden;
}

.mod-box .form-box .cont-box .kefu-box img {
  width: 100%;
}

.mod-box .form-box .submit-box {
  margin-top: 46px;
}

.mod-box .form-box .cont-box button {
  margin-top: 54px;
  border-radius: 2px;
  border: solid 2px #cfa972;
  color: #cfa972;
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 15px;
}

.mod-box .form-box .submit-button {
  background-image: linear-gradient(0deg, #fb3331 0%, #ff712b 100%),
    linear-gradient(#ef4b0a, #ef4b0a);
  background-blend-mode: normal, normal;
  box-shadow: 0px 8px 10px 0px rgba(250, 44, 52, 0.29);
  border-radius: 2px;
  border: solid 0px #ffffff;
  border: none;
  color: #fff;
}
</style>